export const stereaImagePositionToCSS = (posizione) => {
  switch (posizione) {
    case "sinistra_in_alto":
      return "left top";
    case "centrale_in_alto":
      return "left top";
    case "destra_in_alto":
      return "right top";
    case "sinistra_al_centro":
      return "left center";
    case "centrale":
      return "center";
    case "destra_al_centro":
      return "right center";
    case "sinistra_in_basso":
      return "left bottom";
    case "centrale_in_basso":
      return "center bottom";
    case "destra_in_basso":
      return "right bottom";
    default:
      return "center";
  }
};
